var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home bg-gray-50"},[_c('Header',{attrs:{"checked":false}}),_c('AppList',{attrs:{"cat":_vm.cat}}),_c('div',{staticClass:"bg-gray-100 border-t border-gray-300"},[_c('DocList',{attrs:{"cat":_vm.cat}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }